export default __webpack_public_path__ + "static/media/marscapadelogo.a87a617e.svg";